/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/api/league/adapt/bzGoal/file/upload': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * 上传文件
     * @description 上传文件
     */
    post: operations['uploadFile'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/sports': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 获取所有运动
     * @description 获取所有运动列表
     */
    get: operations['getSports_4'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/sports/top': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Top运动列表
     * @description Top Sports
     */
    get: operations['getTopSports'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/matches/list': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 根据不同的参数获取比赛列表
     * @description 根据不同的参数获取比赛列表
     */
    get: operations['getMatches'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/matches/detail/{matchId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 根据比赛id获取比赛详情
     * @description 根据比赛id获取比赛详情
     */
    get: operations['getMatchDetails'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/leagues/top': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 首页Top运动列表
     * @description 获取Top赛事列表
     */
    get: operations['getTopLeagues'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/leagues/sub': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 根据体育类目获取子类目列表
     * @description 通过体育类目获取赛事列表
     */
    get: operations['getSideBar'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/leagues/popular': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 热门赛事卡片
     * @description 获取热门赛事列表
     */
    get: operations['getPopularLeagues'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/leagues/getLeaguesWithOdds': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 根据体育类目获取有赔率的联赛
     * @description 根据体育类目获取有赔率的联赛
     */
    get: operations['getLeaguesWithOdds'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/getBzMatchListByIds': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 获取全部联赛
     * @description 获取全部联赛
     */
    get: operations['getBzMatchListByIds'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/getAllLeague': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 获取全部联赛
     * @description 获取全部联赛
     */
    get: operations['getAllLeague'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/api/league/adapt/bzGoal/events/{sport}/list': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * 获取底部数据3个列表
     * @description 获取底部数据3个列表
     */
    get: operations['getFeaturedEvents'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BasicMatchDetailResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicMatchDetailResult'][];
    };
    'com.bz.league.basic.api.result.BasicMatchDetailResult': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 运动ID
       */
      sportId: number;
      /** @description 运动名称 */
      sportName: string;
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /**
       * Format: int64
       * @description 地区ID
       */
      regionId: number;
      /** @description 地区名称 */
      regionName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /** @description 比赛名称 */
      name: string;
      /** @description 比赛描述 */
      description: string;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /** @description 比赛地点 */
      matchLocation: string;
      /** @description 体育场名称 */
      stadium: string;
      /** @description 裁判姓名 */
      referee: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 状态详情描述 */
      statusDesc: string;
      /** @description 比赛轮次 */
      round: string;
      /** @description 比赛轮次名称 */
      roundname: string;
      /** @description 比赛结果 */
      result: string;
      /** @description 各阶段比赛结果 */
      periods: string;
      /** @description 比赛结果信息 */
      resultInfo: string;
      /** @description 比赛标签（如'热门'、'友谊赛'等） */
      tag: string;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult$MatchTeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult$MatchTeamInfo'];
      /**
       * Format: int64
       * @description 阶段时间
       */
      periodTime: number;
      /** @description  fotmob比赛ID */
      fotmobMatchId: string;
      /** @description 赔率信息 */
      marketOdds: components['schemas']['com.bz.odds.api.dto.MarketOddsDTO'][];
      /** @description sportradar联赛id */
      sportradarLeagueId: string;
      /** @description sportradar地区id */
      sportradarRegionId: string;
      /** @description sportradar运动id */
      sportradarSportId: string;
      /** @description sportradar比赛id */
      sportradarMatchId: string;
      matchEvents: components['schemas']['com.bz.league.basic.api.result.MatchEventResult'][];
      stats: string;
      liveStatusSet: components['schemas']['com.bz.league.basic.api.result.LiveStatusSetResult'][];
    };
    /** @description 客队比赛数据 */
    'com.bz.league.basic.api.result.BasicMatchResult$MatchTeamInfo': {
      /**
       * Format: int64
       * @description 队伍id
       */
      teamId: number;
      /** @description 队伍名称 */
      teamName: string;
      /** @description 队伍logo */
      logoUrl: string;
      /**
       * Format: int32
       * @description 队伍得分
       */
      score: number;
      /** @description 队伍阵容 */
      player: components['schemas']['com.bz.league.basic.api.result.BasicPlayerResult'][];
    };
    /** @description 队伍阵容 */
    'com.bz.league.basic.api.result.BasicPlayerResult': {
      /**
       * Format: int64
       * @description 参赛者ID
       */
      id: number;
      /** @description 姓名 */
      name: string;
      /** @description 全名 */
      fullname: string;
      /** @description 国籍 */
      nationality: string;
      /**
       * Format: int32
       * @description 球衣号码
       */
      shirtNumber: number;
      /** @description 头像图片URL */
      imageUrl: string;
      /**
       * Format: date-time
       * @description 出生日期
       */
      birthDate: string;
      /** @description 身高 */
      height: number;
      /** @description 体重 */
      weight: number;
      /** @description 市场价值 */
      marketValue: number;
      /** @description 位置 */
      position: string;
      /** @description 描述 */
      detail: string;
    };
    'com.bz.league.basic.api.result.LiveStatusSetResult': {
      /** Format: int64 */
      id: number;
      /** Format: int32 */
      matchStatus: number;
      statusDesc: string;
      /** Format: int64 */
      periodTime: number;
    };
    'com.bz.league.basic.api.result.MatchEventResult': {
      /** Format: int64 */
      id: number;
      /** Format: int64 */
      sportId: number;
      /** Format: int64 */
      matchId: number;
      /** Format: int64 */
      fotmobMatchId: number;
      /** Format: int64 */
      sportradarMatchId: number;
      /** Format: int64 */
      eventId: number;
      eventType: string;
      /** Format: int64 */
      teamId: number;
      /** Format: int32 */
      isHome: number;
      /** Format: int64 */
      playerIdPrimary: number;
      /** Format: int64 */
      playerIdSecondary: number;
      hash: string;
      detail: string;
      /** Format: int32 */
      isDeleted: number;
    };
    /** @description 赔率信息 */
    'com.bz.odds.api.dto.MarketOddsDTO': {
      /** Format: int64 */
      id: number;
      siteMatchId: string;
      /** Format: int64 */
      bookmakerId: number;
      code: string;
      /** Format: int32 */
      teamType: number;
      /** Format: int64 */
      teamId: number;
      teamName: string;
      marketTypeCode: string;
      /** Format: int32 */
      marketType: number;
      /** Format: int32 */
      marketSubType: number;
      /** Format: int32 */
      periodType: number;
      rule: string;
      desc: string;
      oddsMarketCode: string;
      /** Format: int64 */
      marketEffectiveTime: number;
      /** Format: int64 */
      marketExpirationTime: number;
      marketCode: string;
      /** Format: int64 */
      effectiveTime: number;
      /** Format: int64 */
      expirationTime: number;
      /** Format: int32 */
      marketStatus: number;
      oddsValue: number;
      preOddsValue: number;
      baseOddsValue: number;
      /** Format: int32 */
      oddsStatus: number;
      /** Format: int32 */
      oddsType: number;
      /** Format: int64 */
      createTime: number;
      /** Format: int64 */
      updateTime: number;
    };
    'com.bz.common.dto.SingleResponseJava.lang.String': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: string;
    };
    'com.bz.common.dto.PageResponseCom.bz.league.basic.api.result.BasicTeamResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      /** Format: int32 */
      totalCount: number;
      /** Format: int32 */
      pageSize: number;
      /** Format: int32 */
      pageIndex: number;
      data: components['schemas']['com.bz.league.basic.api.result.BasicTeamResult'][];
      /** Format: int32 */
      totalPages: number;
    };
    'com.bz.league.basic.api.result.BasicTeamResult': {
      /**
       * Format: int64
       * @description id
       */
      id: number;
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 球队官方名称 */
      name: string;
      /** @description 球队媒体名称 */
      mediumName: string;
      /** @description 主教练 */
      coach: string;
      /** @description 主场 */
      stadium: string;
      /** @description 描述 */
      detail: string;
      /** @description 官方网站 */
      website: string;
      /** @description 成立地点 */
      founded: string;
      /** @description 国家 */
      country: string;
      /** @description 队徽图片URL地址 */
      logoUrl: string;
      /**
       * Format: int32
       * @description 成立年份
       */
      foundedYear: number;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BasicTeamResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicTeamResult'];
    };
    'com.bz.league.basic.api.param.BasicTeamBatchParam': {
      teamIds: number[];
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.BasicTeamResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicTeamResult'][];
    };
    'com.bz.common.dto.PageResponseCom.bz.league.basic.api.result.BasicPlayerResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      /** Format: int32 */
      totalCount: number;
      /** Format: int32 */
      pageSize: number;
      /** Format: int32 */
      pageIndex: number;
      data: components['schemas']['com.bz.league.basic.api.result.BasicPlayerResult'][];
      /** Format: int32 */
      totalPages: number;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BasicPlayerResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicPlayerResult'];
    };
    'com.bz.league.basic.api.result.BasicMatchResult': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 运动ID
       */
      sportId: number;
      /** @description 运动名称 */
      sportName: string;
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /**
       * Format: int64
       * @description 地区ID
       */
      regionId: number;
      /** @description 地区名称 */
      regionName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /** @description 比赛名称 */
      name: string;
      /** @description 比赛描述 */
      description: string;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /** @description 比赛地点 */
      matchLocation: string;
      /** @description 体育场名称 */
      stadium: string;
      /** @description 裁判姓名 */
      referee: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 状态详情描述 */
      statusDesc: string;
      /** @description 比赛轮次 */
      round: string;
      /** @description 比赛轮次名称 */
      roundname: string;
      /** @description 比赛结果 */
      result: string;
      /** @description 各阶段比赛结果 */
      periods: string;
      /** @description 比赛结果信息 */
      resultInfo: string;
      /** @description 比赛标签（如'热门'、'友谊赛'等） */
      tag: string;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult$MatchTeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult$MatchTeamInfo'];
      /**
       * Format: int64
       * @description 阶段时间
       */
      periodTime: number;
      /** @description  fotmob比赛ID */
      fotmobMatchId: string;
      /** @description 赔率信息 */
      marketOdds: components['schemas']['com.bz.odds.api.dto.MarketOddsDTO'][];
      /** @description sportradar联赛id */
      sportradarLeagueId: string;
      /** @description sportradar地区id */
      sportradarRegionId: string;
      /** @description sportradar运动id */
      sportradarSportId: string;
      /** @description sportradar比赛id */
      sportradarMatchId: string;
    };
    'com.bz.common.dto.PageResponseCom.bz.league.basic.api.result.BasicMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      /** Format: int32 */
      totalCount: number;
      /** Format: int32 */
      pageSize: number;
      /** Format: int32 */
      pageIndex: number;
      data: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult'][];
      /** Format: int32 */
      totalPages: number;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BasicMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult'];
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BasicMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult'][];
    };
    'com.bz.common.dto.PageResponseCom.bz.league.basic.api.result.BasicMatchOddsResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      /** Format: int32 */
      totalCount: number;
      /** Format: int32 */
      pageSize: number;
      /** Format: int32 */
      pageIndex: number;
      data: components['schemas']['com.bz.league.basic.api.result.BasicMatchOddsResult'][];
      /** Format: int32 */
      totalPages: number;
    };
    'com.bz.league.basic.api.result.BasicMatchOddsResult': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 运动ID
       */
      sportId: number;
      /** @description 运动名称 */
      sportName: string;
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /**
       * Format: int64
       * @description 地区ID
       */
      regionId: number;
      /** @description 地区名称 */
      regionName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /** @description 比赛名称 */
      name: string;
      /** @description 比赛描述 */
      description: string;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /** @description 比赛地点 */
      matchLocation: string;
      /** @description 体育场名称 */
      stadium: string;
      /** @description 裁判姓名 */
      referee: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 状态详情描述 */
      statusDesc: string;
      /** @description 比赛轮次 */
      round: string;
      /** @description 比赛轮次名称 */
      roundname: string;
      /** @description 比赛结果 */
      result: string;
      /** @description 各阶段比赛结果 */
      periods: string;
      /** @description 比赛结果信息 */
      resultInfo: string;
      /** @description 比赛标签（如'热门'、'友谊赛'等） */
      tag: string;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult$MatchTeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult$MatchTeamInfo'];
      /**
       * Format: int64
       * @description 阶段时间
       */
      periodTime: number;
      /** @description  fotmob比赛ID */
      fotmobMatchId: string;
      /** @description 赔率信息 */
      marketOdds: components['schemas']['com.bz.odds.api.dto.MarketOddsDTO'][];
      /** @description sportradar联赛id */
      sportradarLeagueId: string;
      /** @description sportradar地区id */
      sportradarRegionId: string;
      /** @description sportradar运动id */
      sportradarSportId: string;
      /** @description sportradar比赛id */
      sportradarMatchId: string;
      /** @description 赔率信息 */
      marketOddsDTOList: components['schemas']['com.bz.odds.api.dto.MarketOddsDTO'][];
    };
    'com.bz.league.basic.api.param.BasicMatchBatchParam': {
      matchIds: number[];
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.BasicMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicMatchResult'][];
    };
    'com.bz.common.dto.PageResponseCom.bz.league.basic.api.result.BasicLeagueResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      /** Format: int32 */
      totalCount: number;
      /** Format: int32 */
      pageSize: number;
      /** Format: int32 */
      pageIndex: number;
      data: components['schemas']['com.bz.league.basic.api.result.BasicLeagueResult'][];
      /** Format: int32 */
      totalPages: number;
    };
    'com.bz.league.basic.api.result.BasicLeagueResult': {
      /** Format: int64 */
      id: number;
      name: string;
      /** Format: int64 */
      parentId: number;
      logoUrl: string;
      /** Format: int32 */
      level: number;
      /** Format: int32 */
      sort: number;
      detail: string;
      /** Format: int32 */
      status: number;
      /** Format: int32 */
      isDeleted: number;
      /** Format: int64 */
      currentSeasonId: number;
      fotmobLeagueId: string;
      transfermarktLeagueId: string;
      /** @description 当前赛季的标识，用于关联比赛和队伍数据（参考特定查询接口的参数规则） */
      season: components['schemas']['com.bz.league.basic.api.result.BasicSeasonResult'][];
      /** @description 子级联赛列表，形成树状层级结构，例如顶级联赛下包含的次级联赛 */
      children: components['schemas']['com.bz.league.basic.api.result.BasicLeagueResult'][];
    };
    /** @description 当前赛季的标识，用于关联比赛和队伍数据（参考特定查询接口的参数规则） */
    'com.bz.league.basic.api.result.BasicSeasonResult': {
      /** Format: int64 */
      id: number;
      name: string;
      abbr: string;
      /** Format: int64 */
      leagueId: number;
      detail: string;
      /** Format: int64 */
      startTime: number;
      /** Format: int64 */
      endTime: number;
      /** Format: int32 */
      status: number;
      /** Format: int32 */
      isDeleted: number;
      sportradarSeasonId: string;
      fotmobSeasonId: string;
      transfermarktSeasonId: string;
      /** Format: int32 */
      totalTeams: number;
      /** Format: int32 */
      foreigners: number;
      foreignersPercentage: number;
      averageAge: number;
      averageValue: number;
      /** Format: int32 */
      players: number;
      /** Format: int32 */
      level: number;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BasicLeagueResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicLeagueResult'];
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BasicLeagueResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicLeagueResult'][];
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.TeamTransferResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamTransferResult'][];
    };
    /** @description 球队转会数据 */
    'com.bz.league.basic.api.result.nxgoal.TeamTransferResult': {
      /**
       * Format: int64
       * @description 记录ID
       */
      id: number;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /**
       * Format: int32
       * @description 转会类型
       */
      transferType: number;
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /** @description 转会费用 */
      fee: string;
      /** @description 球员来源 */
      from: string;
      /** @description 球员来源队伍图片url */
      fromImageUrl: string;
      /** @description 球员去向 */
      to: string;
      /** @description 球员去向队伍图片url */
      toImageUrl: string;
      /** @description 位置 */
      position: string;
      /** @description 合同期间 */
      contract: string;
      /**
       * Format: int64
       * @description 市场价值
       */
      marketValue: number;
      /**
       * Format: date-time
       * @description 转会日期
       */
      date: string;
      /** @description 球员头像图片url */
      imageUrl: string;
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.TeamSquadResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamSquadResult'][];
    };
    /** @description 球队阵容信息 */
    'com.bz.league.basic.api.result.nxgoal.TeamSquadResult': {
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /** @description 头衔 */
      title: string;
      /** @description 位置 */
      position: string;
      /** @description 国家代码列表 */
      ccode: string;
      /** @description 国家名称列表 */
      cname: string;
      /**
       * Format: int32
       * @description 球衣号码
       */
      shirtNumber: number;
      /**
       * Format: int32
       * @description 年龄
       */
      age: number;
      /**
       * Format: int32
       * @description 身高(cm)
       */
      height: number;
      /**
       * Format: double
       * @description 市场价值
       */
      marketValue: number;
      /** @description 球员头像URL */
      avatarUrl: string;
      /** @description 是否受伤 */
      injury: boolean;
      /** @description 预计回归时间 */
      expectReturn: string;
      /** @description 球员国籍logoURL */
      nationalLogo: string;
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.SeasonsResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonsResult'][];
    };
    'com.bz.league.basic.api.result.nxgoal.SeasonsResult': {
      /** Format: int64 */
      leagueId: number;
      leagueName: string;
      leagueUrl: string;
      seasonInfoList: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonsResult$SeasonInfo'][];
    };
    'com.bz.league.basic.api.result.nxgoal.SeasonsResult$SeasonInfo': {
      /** Format: int64 */
      seasonId: number;
      seasonName: string;
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.TeamPlayerStatResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamPlayerStatResult'][];
    };
    /** @description 球员统计信息 */
    'com.bz.league.basic.api.result.nxgoal.PlayerStatResult': {
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /** @description 球员头像URL */
      playerLogoUrl: string;
      /** @description 文本型统计值 */
      statsValue: string;
      /** @description 场均文本类型的统计值 */
      statsValuePer90: string;
      /**
       * Format: int32
       * @description 排名
       */
      rank: number;
    };
    /** @description 球员统计数据 */
    'com.bz.league.basic.api.result.nxgoal.TeamPlayerStatResult': {
      /**
       * Format: int64
       * @description 分类ID
       */
      categoryId: number;
      /** @description 分类名称 */
      categoryName: string;
      /** @description 球员列表 */
      playStatList: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamPlayerStatResult$PlayStat'][];
    };
    /** @description 球员统计项 */
    'com.bz.league.basic.api.result.nxgoal.TeamPlayerStatResult$PlayStat': {
      /**
       * Format: int64
       * @description 统计项ID
       */
      statsId: number;
      /** @description 统计项名称 */
      statsName: string;
      /** @description 球员列表 */
      playerStatList: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerStatResult'][];
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.nxgoal.PlayerStatResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerStatResult'][];
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.TeamOverviewResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamOverviewResult'];
    };
    /** @description 球队概览 */
    'com.bz.league.basic.api.result.nxgoal.TeamOverviewResult': {
      basicInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$TeamBasicInfo'];
      /**
       * @description 标签页列表
       * @example [
       *       "overview",
       *       "match",
       *       "stat",
       *       "squad",
       *       "transfers"
       *     ]
       */
      tab: string[];
      /** @description 教练历史列表 */
      coachHistories: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$CoachHistory'][];
      /** @description 历史排位列表 */
      historyPositions: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$HistoryPosition'][];
      /** @description 奖杯列表 */
      trophies: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$Trophy'][];
      /** @description 历史排位列表 */
      historicFifaRanks: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$TeamHistoricFifaRank'][];
    };
    /** @description 教练历史信息 */
    'com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$CoachHistory': {
      /**
       * Format: int64
       * @description ID
       */
      id: number;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 教练名 */
      coachName: string;
      /** @description 教练名头像 */
      imageUrl: string;
      /**
       * Format: double
       * @description 每场得分
       */
      pointsPerGame: number;
      /**
       * Format: int32
       * @description 胜
       */
      win: number;
      /**
       * Format: int32
       * @description 平
       */
      draw: number;
      /**
       * Format: int32
       * @description 负
       */
      loss: number;
      /**
       * Format: double
       * @description 胜率
       */
      winPercentage: number;
      /** @description 赛季名 */
      seasonName: string;
      /**
       * Format: int64
       * @description 联赛ID
       */
      leagueId: number;
      /** @description 联赛名 */
      leagueName: string;
    };
    /** @description 历史排位信息 */
    'com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$HistoryPosition': {
      /**
       * Format: int64
       * @description ID
       */
      id: number;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /**
       * Format: int64
       * @description 联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛图标 */
      leagueUrl: string;
      /**
       * Format: int32
       * @description 联赛级别
       */
      leagueLevel: number;
      /**
       * Format: int32
       * @description 最终排名位置
       */
      finalPosition: number;
      /**
       * Format: int32
       * @description 该赛季联赛总球队数
       */
      totalTeams: number;
    };
    /** @description 球队基础信息 */
    'com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$TeamBasicInfo': {
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /**
       * Format: int32
       * @description 球员总数
       */
      totalPlayer: number;
      /**
       * Format: int32
       * @description 外籍球员
       */
      foreigners: number;
      /**
       * Format: double
       * @description 外籍球员占比%
       */
      foreignersPercentage: number;
      /**
       * Format: double
       * @description 平均年龄
       */
      averageAge: number;
      /**
       * Format: double
       * @description 总身价
       */
      totalMarketValue: number;
      /** @description 主场 */
      stadium: string;
      /** @description 球队图片url */
      teamLogo: string;
    };
    /** @description 历史排位信息 */
    'com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$TeamHistoricFifaRank': {
      /** Format: int64 */
      teamId: number;
      teamName: string;
      teamLogo: string;
      /** Format: int32 */
      teamType: number;
      /** Format: int32 */
      period: number;
      /** Format: int32 */
      rankPoint: number;
      /** Format: int32 */
      totalPoints: number;
      /** Format: int32 */
      preRankPoint: number;
      /** Format: int32 */
      prePoints: number;
      /** Format: int32 */
      pointsDiff: number;
      /** Format: int32 */
      rankDiff: number;
    };
    /** @description 奖杯信息 */
    'com.bz.league.basic.api.result.nxgoal.TeamOverviewResult$Trophy': {
      /**
       * Format: int64
       * @description ID
       */
      id: number;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 奖杯名称 */
      trophyName: string;
      /** @description 地区 */
      area: string;
      /**
       * Format: int32
       * @description 亚军数
       */
      runnerup: number;
      /**
       * Format: int32
       * @description 冠军数
       */
      championship: number;
      /** @description 亚军赛季列表 */
      seasonRunnerup: string;
      /** @description 冠军赛季列表 */
      seasonChampionship: string;
      /**
       * Format: int64
       * @description 联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.TeamMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamMatchResult'];
    };
    /** @description 球队比赛数据 */
    'com.bz.league.basic.api.result.nxgoal.TeamMatchResult': {
      /** @description 比赛列表 */
      matches: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamMatchResult$MatchInfo'][];
    };
    /** @description 比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.TeamMatchResult$MatchInfo': {
      /**
       * Format: int64
       * @description 比赛ID
       * @example 122226
       */
      id: number;
      /**
       * Format: int64
       * @description 当前赛季ID
       * @example 1
       */
      seasonId: number;
      /**
       * @description 当前赛季名称
       * @example 2023-2024
       */
      seasonName: string;
      /**
       * Format: int64
       * @description 联赛ID
       * @example 300001
       */
      leagueId: number;
      /**
       * @description 联赛名称
       * @example 英超联赛
       */
      leagueName: string;
      /**
       * @description 联赛Logo URL
       * @example https://example.com/league_logo.png
       */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 比赛开始时间戳
       * @example 1751643900000
       */
      startTime: number;
      /**
       * Format: int64
       * @description 比赛结束时间戳
       * @example 1751650339000
       */
      endTime: number;
      /**
       * Format: int32
       * @description 比赛状态码
       * @example 100
       * @enum {integer}
       */
      matchStatus: 0 | 1 | 100;
      /**
       * @description 比赛状态描述
       * @example Ended
       * @enum {string}
       */
      statusDesc: 'Not Started' | 'Ended';
      /**
       * @description 轮次
       * @example 15
       */
      round: string;
      /**
       * @description 轮次名称
       * @example 第15轮
       */
      roundname: string;
      /**
       * @description 比赛结果JSON
       * @example {"home":3,"away":0,"winner":"home"}
       */
      result: string;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamMatchResult$TeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.TeamMatchResult$TeamInfo'];
      /**
       * Format: int64
       * @description 比赛时间
       * @example 1751650339000
       */
      periodTime: number;
      /** @description 实时状态集合 */
      liveStatusSet: components['schemas']['com.bz.league.basic.api.result.LiveStatusSetResult'][] | null;
    };
    /** @description 球队信息 */
    'com.bz.league.basic.api.result.nxgoal.TeamMatchResult$TeamInfo': {
      /**
       * Format: int64
       * @description 球队ID
       * @example 84645
       */
      teamId: number;
      /**
       * @description 球队名称
       * @example FC Brest
       */
      teamName: string;
      /**
       * @description 球队Logo URL
       * @example https://example.com/logo.png
       */
      logoUrl: string;
      /**
       * Format: int32
       * @description 球队得分
       * @example 3
       */
      score: number;
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.BasicInfoResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.BasicInfoResult'][];
    };
    /** @description 基础信息 */
    'com.bz.league.basic.api.result.nxgoal.BasicInfoResult': {
      /**
       * Format: int64
       * @description ID
       */
      id: number;
      /** @description 名称 */
      name: string;
      /** @description 图标 */
      imageUrl: string;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.SeasonTeamStatResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonTeamStatResult'];
    };
    /** @description 球队统计数据 */
    'com.bz.league.basic.api.result.nxgoal.SeasonTeamStatResult': {
      /** @description 球队统计列表 */
      teamStat: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonTeamStatResult$TeamStatCategory'][];
    };
    /** @description 球队球员统计信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonTeamStatResult$TeamStat': {
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队Logo URL */
      teamLogoUrl: string;
      /** @description 统计项值 */
      statsValue: string;
      /**
       * Format: int32
       * @description 排名
       */
      rank: number;
    };
    /** @description 球队统计分类 */
    'com.bz.league.basic.api.result.nxgoal.SeasonTeamStatResult$TeamStatCategory': {
      /**
       * Format: int64
       * @description 分类ID
       */
      categoryId: number;
      /** @description 分类名称 */
      categoryName: string;
      /**
       * Format: int64
       * @description 统计项ID
       */
      statsId: number;
      /** @description 统计项名称 */
      statsName: string;
      /**
       * Format: int32
       * @description 排序顺序
       */
      sortOrder: number;
      /**
       * Format: int32
       * @description 统计项排序顺序
       */
      statsSortOrder: number;
      /** @description 球队球员列表 */
      teams: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonTeamStatResult$TeamStat'][];
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.SeasonTableResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonTableResult'];
    };
    /** @description 赛季积分榜数据 */
    'com.bz.league.basic.api.result.nxgoal.SeasonTableResult': {
      table: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonTableResult$TableData'];
    };
    /** @description 积分榜图例 */
    'com.bz.league.basic.api.result.nxgoal.SeasonTableResult$SeasonLegend': {
      /**
       * @description 图例标题
       * @example Premier League
       */
      title: string;
      /**
       * @description 图例颜色
       * @example #000000
       */
      color: string;
      /**
       * @description 适用排名范围
       * @example 1,2,3,4,5,6,7,8,9,10,11,12,13
       */
      indices: string;
      tkey: string;
    };
    /** @description 积分榜球队数据 */
    'com.bz.league.basic.api.result.nxgoal.SeasonTableResult$SeasonTable': {
      /**
       * Format: int64
       * @description 记录ID
       * @example 1
       */
      id: number;
      /**
       * Format: int64
       * @description 赛季ID
       * @example 1
       */
      seasonId: number;
      /**
       * Format: int64
       * @description 球队ID
       * @example 1
       */
      teamId: number;
      /**
       * @description 球队名称
       * @example Team 1
       */
      teamName: string;
      /**
       * @description 球队Logo
       * @example https://example.com/team1.png
       */
      teamLogoUrl: string;
      /**
       * @description 分组名称
       * @example Group 1
       */
      groupName: string;
      /**
       * Format: int32
       * @description 积分榜类型 1:all 2:home 3:away 4:form
       * @example 1
       * @enum {integer}
       */
      tableType: 1 | 2 | 3 | 4;
      /**
       * Format: int32
       * @description 总积分
       * @example 30
       */
      points: number;
      /**
       * Format: int32
       * @description 已踢场次
       * @example 10
       */
      played: number;
      /**
       * Format: int32
       * @description 胜场数
       * @example 10
       */
      win: number;
      /**
       * Format: int32
       * @description 平场数
       * @example 0
       */
      draw: number;
      /**
       * Format: int32
       * @description 负场数
       * @example 0
       */
      loss: number;
      /**
       * @description 进球-失球
       * @example 30-5
       */
      scoresStr: string;
      /**
       * Format: int32
       * @description 净胜球
       * @example 25
       */
      goalConDiff: number;
      /**
       * Format: int32
       * @description 排名位置
       * @example 1
       */
      idx: number;
      /**
       * @description 排名区域颜色
       * @example #00FF00
       */
      qualColor: string;
      /** @description 球队近5场比赛表单 */
      teamForm: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonTableResult$SeasonTeamForm'][];
    };
    /** @description 比赛表单 */
    'com.bz.league.basic.api.result.nxgoal.SeasonTableResult$SeasonTeamForm': {
      /**
       * Format: int32
       * @description 结果 1:胜 0:平 -1:负
       */
      result: number;
      /** @description 结果zhu W:胜 D:平 L:负 */
      resultString: string;
      /** @description 比赛ID */
      matchId: string;
      /**
       * Format: int64
       * @description 比赛时间
       */
      utcTime: number;
      /** @description 主队名称 */
      homeTeam: string;
      /**
       * Format: int64
       * @description 主队ID
       */
      homeTeamId: number;
      /**
       * Format: int64
       * @description 主队进球数
       */
      homeScore: number;
      /** @description 客队名称 */
      awayTeam: string;
      /**
       * Format: int64
       * @description 客队ID
       */
      awayTeamId: number;
      /**
       * Format: int64
       * @description 客队进球数
       */
      awayScore: number;
    };
    /** @description 积分榜数据 */
    'com.bz.league.basic.api.result.nxgoal.SeasonTableResult$TableData': {
      /** @description 积分榜图例说明 */
      seasonLegend: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonTableResult$SeasonLegend'][];
      /** @description 积分榜详细数据 */
      seasonTable: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonTableResult$SeasonTable'][];
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.SeasonPlayerStatResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonPlayerStatResult'];
    };
    /** @description 球员统计数据 */
    'com.bz.league.basic.api.result.nxgoal.SeasonPlayerStatResult': {
      /** @description 球员统计列表 */
      playStat: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonPlayerStatResult$PlayStatCategory'][];
    };
    /** @description 球员统计分类 */
    'com.bz.league.basic.api.result.nxgoal.SeasonPlayerStatResult$PlayStatCategory': {
      /**
       * Format: int64
       * @description 分类ID
       */
      categoryId: number;
      /** @description 分类名称 */
      categoryName: string;
      /**
       * Format: int64
       * @description 统计项ID
       */
      statsId: number;
      /** @description 统计项名称 */
      statsName: string;
      /**
       * Format: int32
       * @description 排序顺序
       */
      sortOrder: number;
      /**
       * Format: int32
       * @description 统计项排序顺序
       */
      statsSortOrder: number;
      /** @description 球员列表 */
      players: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonPlayerStatResult$PlayerStat'][];
    };
    /** @description 球员统计信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonPlayerStatResult$PlayerStat': {
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /** @description 球员头像URL */
      playerLogoUrl: string;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队Logo URL */
      teamLogoUrl: string;
      /** @description 统计项值 */
      statsValue: string;
      /**
       * Format: int32
       * @description 排名
       */
      rank: number;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.SeasonOverviewResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult'];
    };
    /** @description 赛季概览数据 */
    'com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult': {
      info: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult$LeagueInfo'];
      /** @description 赛季列表 */
      seasonList: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult$SeasonInfo'][];
      /**
       * @description 标签页列表
       * @example [
       *       "overview",
       *       "table",
       *       "match",
       *       "stat"
       *     ]
       */
      tab: string[];
      overview: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult$Overview'];
    };
    /** @description 联赛基本统计信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult$About': {
      /**
       * Format: int32
       * @description 参赛球队总数
       * @example 20
       */
      totalTeams: number;
      /**
       * Format: int32
       * @description 球员总数
       * @example 660
       */
      players: number;
      /**
       * Format: int32
       * @description 外援球员数量
       * @example 20
       */
      foreigners: number;
      /**
       * Format: double
       * @description 外援球员占比
       * @example 21.4
       */
      foreignersPercentage: number;
      /**
       * Format: int32
       * @description 球员平均年龄
       * @example 23
       */
      averageAge: number;
      /**
       * Format: double
       * @description 球员平均身价
       * @example 199999999.99
       */
      averageValue: number;
    };
    /** @description 联赛基本信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult$LeagueInfo': {
      /**
       * Format: int64
       * @description 联赛ID
       * @example 300001
       */
      leagueId: number;
      /**
       * @description 联赛名称
       * @example Premier League
       */
      name: string;
      /**
       * @description 联赛Logo URL
       * @example https://example.com/logo.png
       */
      leagueLogoUrl: string;
    };
    /** @description 概览信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult$Overview': {
      about: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult$About'];
    };
    /** @description 赛季信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonOverviewResult$SeasonInfo': {
      /**
       * Format: int64
       * @description 赛季ID
       * @example 1
       */
      seasonId: number;
      /**
       * @description 赛季名称
       * @example 2023-2024
       */
      seasonName: string;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.SeasonMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonMatchResult'];
    };
    /** @description 赛季比赛数据 */
    'com.bz.league.basic.api.result.nxgoal.SeasonMatchResult': {
      /** @description 比赛列表 */
      matches: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonMatchResult$MatchInfo'][];
    };
    /** @description 比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonMatchResult$MatchInfo': {
      /**
       * Format: int64
       * @description 比赛ID
       * @example 122226
       */
      id: number;
      /**
       * Format: int64
       * @description 比赛开始时间戳
       * @example 1751643900000
       */
      startTime: number;
      /**
       * Format: int64
       * @description 比赛结束时间戳
       * @example 1751650339000
       */
      endTime: number;
      /**
       * Format: int32
       * @description 比赛状态码
       * @example 100
       * @enum {integer}
       */
      matchStatus: 0 | 1 | 100;
      /**
       * @description 比赛状态描述
       * @example Ended
       * @enum {string}
       */
      statusDesc: 'Not Started' | 'Ended';
      /**
       * @description 轮次
       * @example 15
       */
      round: string;
      /**
       * @description 轮次名称
       * @example 15
       */
      roundname: string;
      /**
       * @description 比赛结果JSON
       * @example {"home":3,"away":0,"winner":"home"}
       */
      result: string;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonMatchResult$TeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonMatchResult$TeamInfo'];
      /**
       * Format: int64
       * @description 比赛时间
       * @example 1751650339000
       */
      periodTime: number;
      /** @description 实时状态集合 */
      liveStatusSet: components['schemas']['com.bz.league.basic.api.result.LiveStatusSetResult'][] | null;
    };
    /** @description 球队信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonMatchResult$TeamInfo': {
      /**
       * Format: int64
       * @description 球队ID
       * @example 84645
       */
      teamId: number;
      /**
       * @description 球队名称
       * @example FC Brest
       */
      teamName: string;
      /**
       * @description 球队Logo URL
       * @example https://example.com/logo.png
       */
      logoUrl: string;
      /**
       * Format: int32
       * @description 球队得分
       * @example 3
       */
      score: number;
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.nxgoal.SeasonBestPlayerResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonBestPlayerResult'][];
    };
    'com.bz.league.basic.api.result.nxgoal.SeasonBestPlayerResult': {
      /**
       * Format: int64
       * @description 统计项ID
       */
      statsId: number;
      /**
       * @description 统计项Key
       * @example top_rated
       * @enum {string}
       */
      statsKey: 'top_rated' | 'top_scorer' | 'top_assist';
      /**
       * @description 统计名
       * @example top rated
       * @enum {string}
       */
      statsName: 'top rated' | 'top scorer' | 'top assist';
      /**
       * @description 统计项格式
       * @example numeric
       */
      format: string;
      /**
       * @description 统计项显示类型
       * @example graph
       */
      displayType: string;
      /**
       * Format: int32
       * @description 统计项排序
       * @example 1
       */
      sortOrder: number;
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /** @description 球员头像URL */
      playerLogoUrl: string;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队Logo URL */
      teamLogoUrl: string;
      /**
       * Format: int32
       * @description 排名
       */
      rank: number;
      /** @description 统计值 */
      statsValue: string;
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.nxgoal.RoundResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.RoundResult'][];
    };
    /** @description 轮次数据 */
    'com.bz.league.basic.api.result.nxgoal.RoundResult': {
      /**
       * Format: int32
       * @description 轮次ID
       */
      roundId: number;
      /** @description 轮次名称 */
      roundName: string;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.RoundBestLineupResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.RoundBestLineupResult'];
    };
    /** @description 轮次最佳阵容 */
    'com.bz.league.basic.api.result.nxgoal.RoundBestLineupResult': {
      roundInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.RoundBestLineupResult$RoundInfo'];
      /** @description 最佳阵容球员列表 */
      players: components['schemas']['com.bz.league.basic.api.result.nxgoal.RoundBestLineupResult$BestLineupPlayer'][];
    };
    /** @description 最佳阵容球员信息 */
    'com.bz.league.basic.api.result.nxgoal.RoundBestLineupResult$BestLineupPlayer': {
      /**
       * Format: int64
       * @description 阵容ID
       */
      lineupId: number;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队Logo URL */
      teamLogoUrl: string;
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /** @description 球员头像URL */
      playerLogoUrl: string;
      /**
       * Format: int64
       * @description 比赛ID
       */
      matchId: number;
      /**
       * Format: double
       * @description 球员评分
       */
      rating: number;
      /** @description 评分颜色 */
      ratingColor: string;
      /** @description 是否为最高评分 */
      isTopRating: boolean;
      /**
       * Format: double
       * @description 布局X坐标
       */
      layoutX: number;
      /**
       * Format: double
       * @description 布局Y坐标
       */
      layoutY: number;
      /**
       * Format: double
       * @description 布局宽度
       */
      layoutWidth: number;
      /**
       * Format: double
       * @description 布局高度
       */
      layoutHeight: number;
      /**
       * Format: int32
       * @description 排序顺序
       */
      sortOrder: number;
    };
    /** @description 轮次信息 */
    'com.bz.league.basic.api.result.nxgoal.RoundBestLineupResult$RoundInfo': {
      /** @description 轮次ID */
      roundId: string;
      /** @description 轮次名称 */
      roundName: string;
      /**
       * Format: int64
       * @description 联赛ID
       */
      leagueId: number;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.PlayerStatsResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerStatsResult'][];
    };
    /** @description 球员统计数据 */
    'com.bz.league.basic.api.result.nxgoal.PlayerStatsResult': {
      /**
       * Format: int64
       * @description 分类ID
       */
      categoryId: number;
      /** @description 分类名称 */
      categoryName: string;
      /** @description 统计项列表 */
      playStatList: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerStatsResult$PlayStat'][];
    };
    /** @description 球员统计项 */
    'com.bz.league.basic.api.result.nxgoal.PlayerStatsResult$PlayStat': {
      /**
       * Format: int64
       * @description 统计项ID
       */
      statsId: number;
      /** @description 统计项名称 */
      statsName: string;
      /** @description 文本型统计值 */
      statsValue: string;
      /** @description 场均文本类型的统计值 */
      statsValuePer90: string;
      /**
       * Format: int32
       * @description 排名
       */
      rank: number;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.PlayerOverviewResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerOverviewResult'];
    };
    /** @description 球员概览数据 */
    'com.bz.league.basic.api.result.nxgoal.PlayerOverviewResult': {
      basicInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerOverviewResult$PlayerBasicInfo'];
      /** @description 身价历史数据 */
      marketValueHistory: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerOverviewResult$MarketValueHistory'][];
      /** @description 奖杯记录 */
      trophies: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerOverviewResult$TrophyRecord'][];
    };
    /** @description 身价历史记录 */
    'com.bz.league.basic.api.result.nxgoal.PlayerOverviewResult$MarketValueHistory': {
      /**
       * Format: int64
       * @description 记录ID
       */
      id: number;
      /**
       * Format: int64
       * @description 时间戳(毫秒)
       */
      x: number;
      /**
       * Format: double
       * @description 身价金额
       */
      y: number;
      /** @description 市场价值 */
      mw: string;
      /**
       * Format: date-time
       * @description 日期
       */
      datumMw: string;
      /** @description 球队名称 */
      teamName: string;
      /**
       * Format: int32
       * @description 球员年龄
       */
      age: number;
      /** @description 球队logo URL */
      logo: string;
    };
    /** @description 球员基础信息 */
    'com.bz.league.basic.api.result.nxgoal.PlayerOverviewResult$PlayerBasicInfo': {
      /**
       * Format: int64
       * @description 球员ID
       */
      id: number;
      /** @description 球员姓名 */
      name: string;
      /** @description 球员全名 */
      fullname: string;
      /** @description 国籍 */
      nationality: string;
      /**
       * Format: int32
       * @description 球衣号码
       */
      shirtNumber: number;
      /** @description 头像图片URL */
      imageUrl: string;
      /**
       * Format: date-time
       * @description 出生日期
       */
      birthDate: string;
      /**
       * Format: int32
       * @description 年龄
       */
      age: number;
      /**
       * Format: double
       * @description 身高（米）
       */
      height: number;
      /**
       * Format: double
       * @description 体重（公斤）
       */
      weight: number;
      /**
       * Format: double
       * @description 当前市场价值（万元）
       */
      marketValue: number;
      /** @description 位置 */
      position: string;
      /** @description 常用脚 */
      preferredFoot: string;
      /** @description 国籍图标URL */
      nationalLogo: string;
    };
    /** @description 奖杯记录 */
    'com.bz.league.basic.api.result.nxgoal.PlayerOverviewResult$TrophyRecord': {
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队logo URL */
      teamLogoUrl: string;
      /** @description 球队所属国家代码 */
      teamCcode: string;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛logo URL */
      leagueLogoUrl: string;
      /** @description 夺冠赛季列表 */
      seasonName: string;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.PlayerCareerResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerCareerResult'];
    };
    /** @description 球员生涯数据 */
    'com.bz.league.basic.api.result.nxgoal.PlayerCareerResult': {
      /** @description 俱乐部生涯记录 */
      clubCareers: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerCareerResult$ClubCareer'][];
      /** @description 国家队生涯记录 */
      nationalCareers: components['schemas']['com.bz.league.basic.api.result.nxgoal.PlayerCareerResult$NationalCareer'][];
    };
    /** @description 俱乐部生涯记录 */
    'com.bz.league.basic.api.result.nxgoal.PlayerCareerResult$ClubCareer': {
      /**
       * Format: int64
       * @description 记录ID
       */
      id: number;
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球员头像URL */
      teamLogo: string;
      /** @description 球队所属国家代码 */
      teamCcode: string;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /**
       * Format: int64
       * @description 联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛名称logoURL */
      leagueLogo: string;
      /**
       * Format: int32
       * @description 上场次数
       */
      apps: number;
      /**
       * Format: int32
       * @description 进球数
       */
      goal: number;
      /**
       * Format: int32
       * @description 助攻数
       */
      assist: number;
      /** @description 黄/黄红/红牌数 */
      card: string;
      /**
       * Format: int32
       * @description 上场时间（分钟）
       */
      mins: number;
    };
    /** @description 国家队生涯记录 */
    'com.bz.league.basic.api.result.nxgoal.PlayerCareerResult$NationalCareer': {
      /**
       * Format: int64
       * @description 记录ID
       */
      id: number;
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队所属国家代码 */
      teamCcode: string;
      nationalLogo: string;
      /**
       * Format: int32
       * @description 球衣号码
       */
      shirtNumber: number;
      /** @description 首秀时间 */
      debut: string;
      /**
       * Format: int32
       * @description 上场次数
       */
      apps: number;
      /**
       * Format: int32
       * @description 进球数
       */
      goal: number;
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.MatchTopPlayerResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchTopPlayerResult'][];
    };
    'com.bz.league.basic.api.result.nxgoal.MatchTopPlayerResult': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      matchId: number;
      /**
       * Format: int64
       * @description 统计项ID
       */
      statsId: number;
      /**
       * @description 统计项Key
       * @example top_rated
       * @enum {string}
       */
      statsKey: 'top_rated' | 'top_scorer' | 'top_assist';
      /**
       * @description 统计名
       * @example top rated
       * @enum {string}
       */
      statsName: 'top rated' | 'top scorer' | 'top assist';
      /**
       * @description 统计项格式
       * @example numeric
       */
      format: string;
      /**
       * @description 统计项显示类型
       * @example graph
       */
      displayType: string;
      /**
       * Format: int32
       * @description 统计项排序
       * @example 1
       */
      sortOrder: number;
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /** @description 球员头像URL */
      playerLogoUrl: string;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队Logo URL */
      teamLogoUrl: string;
      /**
       * Format: int32
       * @description 排名
       */
      rank: number;
      /** @description 统计值 */
      statsValue: string;
      /** @description 守门员 */
      goalkeeper: boolean;
      /** @description 最佳球员 */
      potm: boolean;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.MatchStatsResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult'];
    };
    /** @description 比赛统计结果容器，包含球队统计和球员统计数据 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult': {
      teamStats: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats'];
      playerStats: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$PlayerStats'];
    };
    /** @description 比赛球员统计数据 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$PlayerStats': {
      /** @description 统计类别列表 */
      stats: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$PlayerStats$StatsCategory'][];
    };
    /** @description 球员统计项 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$PlayerStats$Player': {
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员姓名 */
      playerName: string;
      /** @description 球员头像URL */
      playerLogoUrl: string;
      /** @description 是否守门员 */
      goalkeeper: boolean;
      /** @description 是否最佳球员 */
      potm: boolean;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队头像URL */
      teamLogoUrl: string;
      /** @description 统计值 */
      statsValue: string;
      /**
       * Format: int32
       * @description 排名
       */
      rank: number;
      /** @description 是否高亮显示 */
      highlighted: boolean;
    };
    /** @description 具体统计项 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$PlayerStats$Stats': {
      /**
       * Format: int64
       * @description 统计项ID
       */
      statsId: number;
      /** @description 统计项键名 */
      statsKey: string;
      /** @description 统计项名称 */
      statsName: string;
      /** @description 数据格式 */
      format: string;
      /** @description 展示类型 */
      displayType: string;
      /** @description 数据单位 */
      unit: string;
      /**
       * Format: int32
       * @description 排序序号
       */
      sortOrder: number;
      /** @description 球员统计项列表 */
      players: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$PlayerStats$Player'][];
    };
    /** @description 统计类别 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$PlayerStats$StatsCategory': {
      /**
       * Format: int64
       * @description 类别ID
       */
      id: number;
      /** @description 类别键名 */
      key: string;
      /** @description 类别名称 */
      name: string;
      /**
       * Format: int32
       * @description 排序序号
       */
      sortOrder: number;
      /** @description 统计项列表 */
      stats: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$PlayerStats$Stats'][];
    };
    /** @description 球队统计信息 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats': {
      /** @description 分时段统计数据，key为时段标识(如ALL/1st/2nd) */
      period: {
        [
          key: string
        ]: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$PeriodData'];
      };
    };
    /** @description 比赛球队颜色配置 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$MatchTeamColor': {
      /** @description 比赛阶段标识 (例如: ALL, 1st, 2nd) */
      periods: string;
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 深色模式颜色配置 */
      darkMode: string;
      /** @description 浅色模式颜色配置 */
      lightMode: string;
      /** @description 深色字体模式颜色配置 */
      fontDarkMode: string;
      /** @description 浅色字体模式颜色配置 */
      fontLightMode: string;
    };
    /** @description 单时段统计数据 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$PeriodData': {
      /** @description 统计类别列表 */
      stats: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$StatsCategory'][];
      /** @description 球队颜色配置 */
      teamColors: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$MatchTeamColor'][];
    };
    /** @description 具体统计项 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$Stats': {
      /**
       * Format: int64
       * @description 统计项ID
       */
      statsId: number;
      /** @description 统计项键名 */
      statsKey: string;
      /** @description 统计项名称 */
      statsName: string;
      /** @description 数据格式 */
      format: string;
      /** @description 展示类型 */
      displayType: string;
      /** @description 数据单位 */
      unit: string;
      /**
       * Format: int32
       * @description 排序序号
       */
      sortOrder: number;
      /** @description 是否高亮显示 */
      highlighted: boolean;
      /** @description 球队统计列表 */
      teams: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$Team'][];
    };
    /** @description 统计类别 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$StatsCategory': {
      /**
       * Format: int64
       * @description 类别ID
       */
      id: number;
      /** @description 类别键名 */
      key: string;
      /** @description 类别名称 */
      name: string;
      /**
       * Format: int32
       * @description 排序序号
       */
      sortOrder: number;
      /** @description 统计项列表 */
      stats: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$Stats'][];
    };
    /** @description 球队统计数据 */
    'com.bz.league.basic.api.result.nxgoal.MatchStatsResult$TeamStats$Team': {
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 比赛阶段标识 (例如: ALL, 1st, 2nd) */
      periods: string;
      /** @description 统计值 */
      statsValue: string;
      /**
       * Format: int32
       * @description 排名
       */
      rank: number;
      /** @description 是否高亮显示 */
      highlighted: boolean;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.MatchLineupResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchLineupResult'];
    };
    /** @description 比赛阵容结果 */
    'com.bz.league.basic.api.result.nxgoal.MatchLineupResult': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      matchId: number;
      homeTeam: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Team'];
      awayTeam: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Team'];
      filterClub: boolean;
    };
    /** @description 球员信息 */
    'com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Player': {
      /**
       * Format: int64
       * @description 球员ID
       */
      playerId: number;
      /** @description 球员名称 */
      playerName: string;
      /** @description 球员头像URL */
      playerLogoUrl: string;
      /**
       * Format: int64
       * @description 球员所属俱乐部球队ID
       */
      clubTeamId: number;
      /** @description 球员所属俱乐部球队名称 */
      clubTeamName: string;
      /** @description 球员所属俱乐部球队logo URL */
      clubTeamLogoUrl: string;
      /**
       * Format: int32
       * @description 球员年龄
       */
      age: number;
      /**
       * Format: int32
       * @description 球员常用位置id
       */
      usualPlayingPositionId: number;
      /** @description 球员常用位置名称 */
      usualPlayingPositionName: string;
      /** @description 球衣号码 */
      shirtNumber: string;
      /** @description 国家名称 */
      countryName: string;
      /** @description 国家代码 */
      countryCode: string;
      /** @description 球员国家logo URL */
      countryLogoUrl: string;
      /**
       * Format: int32
       * @description 球员身价
       */
      marketValue: number;
      /**
       * Format: double
       * @description 球员评分
       */
      rating: number;
      /**
       * Format: double
       * @description 赛季评分
       */
      seasonRating: number;
      /**
       * Format: int32
       * @description 赛季进球数
       */
      seasonGoals: number;
      /**
       * Format: int32
       * @description 赛季助攻数
       */
      seasonAssists: number;
      /** @description 是否本场比赛最佳球员 */
      playerOfTheMatch: boolean;
      /**
       * Format: int32
       * @description 球员角色
       */
      playerRole: number;
      /**
       * Format: int32
       * @description 球员伤病id
       */
      injuryId: number;
      /** @description 球员伤病描述 */
      injuryDescription: string;
      /** @description 球员伤病预计返回时间 */
      expectedReturn: string;
      /**
       * Format: double
       * @description 水平布局X坐标
       */
      horizontalLayoutX: number;
      /**
       * Format: double
       * @description 水平布局Y坐标
       */
      horizontalLayoutY: number;
      /**
       * Format: double
       * @description 水平布局宽度
       */
      horizontalLayoutWidth: number;
      /**
       * Format: double
       * @description 水平布局高度
       */
      horizontalLayoutHeight: number;
      /**
       * Format: double
       * @description 垂直布局X坐标
       */
      verticalLayoutX: number;
      /**
       * Format: double
       * @description 垂直布局Y坐标
       */
      verticalLayoutY: number;
      /**
       * Format: double
       * @description 垂直布局宽度
       */
      verticalLayoutWidth: number;
      /**
       * Format: double
       * @description 垂直布局高度
       */
      verticalLayoutHeight: number;
    };
    /** @description 球队阵容信息 */
    'com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Team': {
      /**
       * Format: int64
       * @description 球队ID
       */
      teamId: number;
      /** @description 球队名称 */
      teamName: string;
      /** @description 球队logo URL */
      teamLogoUrl: string;
      /**
       * Format: double
       * @description 球队评分
       */
      rating: number;
      /** @description 阵型 */
      formation: string;
      /**
       * Format: double
       * @description 首发平均年龄
       */
      averageStarterAge: number;
      /**
       * Format: int32
       * @description 首发总身价
       */
      totalStarterMarketValue: number;
      /** @description 首发球员列表 */
      starters: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Player'][];
      coach: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Player'];
      /** @description 替补球员列表 */
      subs: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Player'][];
      /** @description 板凳球员列表 */
      bench: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Player'][];
      /** @description 不可用球员列表 */
      unavailable: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchLineupResult$Player'][];
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult'];
    };
    /** @description 赛季淘汰赛数据 */
    'com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult': {
      /** @description 抽签比赛信息 */
      draw: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$DrawStageInfo'][];
      /** @description 淘汰赛所有轮次比赛信息 */
      rounds: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$Round'][];
      bronzeFinal: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$AggregatedMatchResult'];
    };
    /** @description 淘汰赛单场比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$AggregatedMatchResult': {
      /**
       * Format: int32
       * @description 主队得分
       */
      homeScore: number;
      /** @description 主队名称 */
      homeTeamName: string;
      /**
       * Format: int64
       * @description 主队id
       */
      homeTeamId: number;
      /** @description 主队简称 */
      homeTeamShortName: string;
      /** @description 主队logo地址 */
      homeTeamLogoUrl: string;
      /**
       * Format: int32
       * @description 客队得分
       */
      awayScore: number;
      /** @description 客队名称 */
      awayTeamName: string;
      /**
       * Format: int64
       * @description 客队id
       */
      awayTeamId: number;
      /** @description 客队简称 */
      awayTeamShortName: string;
      /** @description 客队logo地址 */
      awayTeamLogoUrl: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      status: number;
      /** @description 比赛状态 */
      statusDesc: string;
      /** @description 比赛id列表（淘汰赛可能有多场比赛） */
      matches: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$MatchResult'][];
    };
    /** @description 比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$DrawInfo': {
      /** @description 抽签分组 */
      post: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$Post'][];
      /** @description 比赛结果 */
      drawResult: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$AggregatedMatchResult'][];
    };
    /** @description 抽签比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$DrawStageInfo': {
      /** @description 阶段 */
      stage: string;
      /** @description 比赛信息 */
      draws: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$DrawInfo'][];
    };
    /** @description 分组队伍信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$DrawTeamInfo': {
      /** Format: int64 */
      id: number;
      /** @description 名称 */
      name: string;
      /** @description 简称 */
      shortName: string;
      /**
       * Format: int32
       * @description 排名
       */
      tablePosition: number;
      /** @description 队伍logo地址 */
      logoUrl: string;
    };
    /** @description 单场比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$MatchResult': {
      /**
       * Format: int64
       * @description 比赛id
       */
      matchId: number;
      /**
       * Format: int32
       * @description 主队得分
       */
      homeScore: number;
      /** @description 主队名称 */
      homeTeamName: string;
      /**
       * Format: int64
       * @description 主队id
       */
      homeTeamId: number;
      /** @description 主队简称 */
      homeTeamShortName: string;
      /** @description 主队logo地址 */
      homeTeamLogoUrl: string;
      /**
       * Format: int32
       * @description 客队得分
       */
      awayScore: number;
      /** @description 客队名称 */
      awayTeamName: string;
      /**
       * Format: int64
       * @description 客队id
       */
      awayTeamId: number;
      /** @description 客队简称 */
      awayTeamShortName: string;
      /** @description 客队logo地址 */
      awayTeamLogoUrl: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      status: number;
      /** @description 比赛状态 */
      statusDesc: string;
      /**
       * Format: int64
       * @description 比赛开始时间
       */
      startTime: number;
    };
    /** @description 抽签分组 */
    'com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$Post': {
      /** @description 分组队伍信息 */
      teams: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$DrawTeamInfo'][];
    };
    /** @description 淘汰赛所有轮次比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$Round': {
      /** @description 阶段 */
      stage: string;
      /** @description 比赛信息 */
      matchups: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonKnockoutResult$AggregatedMatchResult'][];
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult'];
    };
    'com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult': {
      nxGoalMatchInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$NxGoalMatchInfo'];
      /** @description 30天内推荐比赛信息 */
      upNextMatchInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$UpNextMatchInfo'][];
      matchFacts: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$MatchFacts'];
      /** @description 主队和客队近5场比赛数据 */
      teamFormList: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$NxGoalMatchInfo'][];
      info: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$Info'];
    };
    /** @description 比赛场馆、日期信息 */
    'com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$Info': {
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛图标 */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /** @description 场馆信息 */
      stadium: string;
    };
    'com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$MatchDetailEventResult': {
      type: string;
      timeStr: string;
      /** Format: int32 */
      time: number;
      /** Format: int64 */
      playerId: number;
      playerName: string;
      imageUrl: string;
      /** Format: int64 */
      assistPlayerId: number;
      assistName: string;
      assistStr: string;
      isHome: boolean;
      injuredPlayerOut: boolean;
      newScore: number[];
      penShootoutScore: number[];
      /** Format: int64 */
      sort: number;
      /** Format: int32 */
      homeScore: number;
      /** Format: int32 */
      awayScore: number;
      card: string;
      minutesAddedStr: string;
      halfStrShort: string;
      /** Format: int64 */
      playerInId: number;
      playerInName: string;
      /** Format: int64 */
      playerOutId: number;
      playerOutName: string;
      varDecision: string;
      ownGoal: boolean;
      isPenaltyShootoutEvent: boolean;
      goalDescription: string;
      cardDescription: string;
    };
    /** @description 比赛事件 */
    'com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$MatchFacts': {
      events: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$MatchDetailEventResult'][];
      penaltyShootoutEvents: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$MatchDetailEventResult'][];
    };
    /** @description 主队和客队近5场比赛数据 */
    'com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$NxGoalMatchInfo': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /** @description 比赛结果 */
      result: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 比赛状态描述 */
      statusDesc: string;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$TeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$TeamInfo'];
    };
    /** @description 客队比赛数据 */
    'com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$TeamInfo': {
      /**
       * Format: int64
       * @description 队伍id
       */
      teamId: number;
      /** @description 队伍名称 */
      teamName: string;
      /** @description 队伍logo */
      logoUrl: string;
      /**
       * Format: int32
       * @description 球队得分
       * @example 3
       */
      score: number;
    };
    /** @description 30天内推荐比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$UpNextMatchInfo': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /**
       * Format: int64
       * @description 排序
       */
      order: number;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$TeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.MatchDetailInfoResult$TeamInfo'];
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BasicMatchDetailResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BasicMatchDetailResult'];
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.nxgoal.NxGoalFootballMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.NxGoalFootballMatchResult'][];
    };
    'com.bz.league.basic.api.result.nxgoal.NxGoalFootballMatchResult': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 状态详情描述 */
      statusDesc: string;
      /** @description 比赛轮次 */
      round: string;
      /** @description 比赛轮次名称 */
      roundname: string;
      /** @description 比赛结果 */
      result: string;
      /** @description 各阶段比赛结果 */
      periods: string;
      /** @description 比赛标签 */
      tag: string;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.NxGoalFootballMatchResult$MatchTeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.NxGoalFootballMatchResult$MatchTeamInfo'];
      /**
       * Format: int64
       * @description 阶段时间
       */
      periodTime: number;
      /** @description 是否分组赛 */
      isGroup: boolean;
      /** @description 分组名称 */
      groupName: string;
      /** @description 博彩公司赔率数据 */
      marketOdds: components['schemas']['com.bz.odds.api.dto.MarketOddsDTO'][];
      /** @description 比赛状态列表 */
      liveStatusSet: components['schemas']['com.bz.league.basic.api.result.LiveStatusSetResult'][];
    };
    /** @description 客队比赛数据 */
    'com.bz.league.basic.api.result.nxgoal.NxGoalFootballMatchResult$MatchTeamInfo': {
      /**
       * Format: int64
       * @description 队伍id
       */
      teamId: number;
      /** @description 队伍名称 */
      teamName: string;
      /** @description 队伍logo */
      logoUrl: string;
      /** Format: int32 */
      score: number;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult'];
    };
    'com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult': {
      /** @description 联赛信息 */
      leagueInfos: components['schemas']['com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult$LeagueInfo'][];
      /** @description 比赛信息 */
      matchInfos: components['schemas']['com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult$MatchInfo'][];
    };
    /** @description 联赛信息 */
    'com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult$LeagueInfo': {
      /**
       * Format: int64
       * @description 联赛ID
       * @example 84645
       */
      leagueId: number;
      /**
       * @description 联赛名称
       * @example FC Brest
       */
      leagueName: string;
      /**
       * @description 联赛Logo URL
       * @example https://example.com/logo.png
       */
      logoUrl: string;
    };
    /** @description 比赛信息 */
    'com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult$MatchInfo': {
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 结果 */
      result: string;
      /** @description 状态详情描述 */
      statusDesc: string;
      homeTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult$TeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult$TeamInfo'];
    };
    /** @description 球队信息 */
    'com.bz.league.basic.api.result.nxgoal.HeadToHeadMatchResult$TeamInfo': {
      /**
       * Format: int64
       * @description 球队ID
       * @example 84645
       */
      teamId: number;
      /**
       * @description 球队名称
       * @example FC Brest
       */
      teamName: string;
      /**
       * @description 球队Logo URL
       * @example https://example.com/logo.png
       */
      logoUrl: string;
      /**
       * Format: int32
       * @description 球队得分
       * @example 3
       */
      score: number;
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.LeagueInfoResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.LeagueInfoResult'][];
    };
    /** @description 球员生涯数据 */
    'com.bz.league.basic.api.result.nxgoal.LeagueInfoResult': {
      /**
       * Format: int64
       * @description 联赛id
       */
      id: number;
      /** @description 联赛名称 */
      name: string;
      /** @description 联赛logo */
      logoUrl: string;
      /**
       * Format: int64
       * @description 父联赛id
       */
      parentId: number;
    };
    'com.bz.common.dto.SingleResponse': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: Record<string, never>;
    };
    'com.bz.common.dto.SingleResponseJava.lang.Boolean': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: boolean;
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.domain.aggregate.MatchDocument': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.domain.aggregate.MatchDocument'][];
    };
    'com.bz.league.basic.domain.aggregate.BasicPlayer': {
      /** Format: int64 */
      id: number;
      name: string;
      fullname: string;
      nationality: string;
      /** Format: int32 */
      shirtNumber: number;
      imageUrl: string;
      /** Format: date-time */
      birthDate: string;
      /** Format: double */
      height: number;
      /** Format: double */
      weight: number;
      /** Format: double */
      marketValue: number;
      position: string;
      detail: string;
      /** Format: int32 */
      isDeleted: number;
      preferredFoot: string;
      nationalLogo: string;
      fotmobPlayerId: string;
    };
    'com.bz.league.basic.domain.aggregate.LiveStatusSet': {
      /** Format: int64 */
      id: number;
      /** Format: int32 */
      matchStatus: number;
      /** Format: int64 */
      periodTime: number;
      statusDesc: string;
    };
    'com.bz.league.basic.domain.aggregate.MatchDocument': {
      /** Format: int64 */
      id: number;
      /** Format: int64 */
      leagueId: number;
      leagueName: string;
      leagueLogoUrl: string;
      /** Format: int64 */
      regionId: number;
      regionName: string;
      regionLogoUrl: string;
      /** Format: int64 */
      sportId: number;
      sportName: string;
      sportLogoUrl: string;
      /** Format: int64 */
      seasonId: number;
      seasonName: string;
      description: string;
      name: string;
      /** Format: int64 */
      startTime: number;
      /** Format: int64 */
      endTime: number;
      matchLocation: string;
      stadium: string;
      referee: string;
      /** Format: int32 */
      matchStatus: number;
      statusDesc: string;
      round: string;
      roundname: string;
      periods: string;
      result: string;
      tag: string;
      /** Format: int64 */
      periodTime: number;
      /** Format: int64 */
      homeTeamId: number;
      homeTeamName: string;
      homeTeamLogoUrl: string;
      /** Format: int32 */
      homeScore: number;
      /** Format: int64 */
      awayTeamId: number;
      awayTeamName: string;
      awayTeamLogoUrl: string;
      /** Format: int32 */
      awayScore: number;
      hasOdds: boolean;
      isGroup: boolean;
      groupName: string;
      marketOdds: components['schemas']['com.bz.odds.api.dto.MarketOddsDTO'][];
      liveStatusSet: components['schemas']['com.bz.league.basic.domain.aggregate.LiveStatusSet'][];
      homeTeamInfo: components['schemas']['com.bz.league.basic.domain.aggregate.MatchExtendDocument$MatchTeamInfo'];
      awayTeamInfo: components['schemas']['com.bz.league.basic.domain.aggregate.MatchExtendDocument$MatchTeamInfo'];
      sportradarLeagueId: string;
      sportradarRegionId: string;
      sportradarSportId: string;
      sportradarMatchId: string;
    };
    'com.bz.league.basic.domain.aggregate.MatchExtendDocument$MatchTeamInfo': {
      /** Format: int64 */
      teamId: number;
      teamName: string;
      logoUrl: string;
      /** Format: int32 */
      score: number;
      players: components['schemas']['com.bz.league.basic.domain.aggregate.BasicPlayer'][];
    };
    'com.bz.common.dto.SingleResponseCom.bz.odds.api.dto.response.MarketOddsBatchResponse': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.odds.api.dto.response.MarketOddsBatchResponse'];
    };
    'com.bz.odds.api.dto.response.MarketOddsBatchResponse': {
      marketOdds: {
        [key: string]: components['schemas']['com.bz.odds.api.dto.MarketOddsDTO'][];
      };
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.LeagueInfoResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.LeagueInfoResult'][];
    };
    'com.bz.league.basic.api.result.LeagueInfoResult': {
      /** Format: int64 */
      sportId: number;
      sportName: string;
      sportLogoUrl: string;
      /** Format: int64 */
      regionId: number;
      regionName: string;
      regionLogoUrl: string;
      /** Format: int64 */
      leagueId: number;
      leagueName: string;
      leagueLogoUrl: string;
    };
    'com.bz.common.dto.MultiResponseCom.bz.league.basic.api.result.nxgoal.SeasonBestPlayerResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.nxgoal.SeasonBestPlayerResult'][];
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.server.adapt.result.BzTopLeagueResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.server.adapt.result.BzTopLeagueResult'][];
    };
    'com.bz.league.basic.server.adapt.result.BzTopLeagueResult': {
      /**
       * Format: int64
       * @description 体育运动ID
       */
      sportId: number;
      /** @description 体育运动名称 */
      sportName: string;
      /** @description 体育运动logo */
      sportLogoUrl: string;
      /**
       * Format: int64
       * @description 国家/地区ID
       */
      regionId: number;
      /** @description 国家/地区名称 */
      regionName: string;
      /** @description 国家/地区名称logo */
      regionLogoUrl: string;
      /**
       * Format: int64
       * @description 具体联赛ID
       */
      leagueId: number;
      /** @description 具体联赛名称 */
      leagueName: string;
      /** @description 具体联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int32
       * @description 类目级别
       */
      level: number;
      /**
       * Format: int32
       * @description 同一层级内的显示顺序，数值越小越靠前
       */
      sort: number;
      /** @description 对联赛的简要介绍或说明 */
      detail: string;
      /**
       * Format: int32
       * @description 赛季状态，0表示未开始，1表示进行中，2表示已结束，3表示已取消
       */
      status: number;
      /** @description 赛事所在地国家 */
      country: string;
      /**
       * Format: int64
       * @description 当前赛季ID
       */
      currentSeasonId: number;
      /** @description 当前赛季名称 */
      currentSeasonName: string;
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BzMatchListResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BzMatchListResult'];
    };
    'com.bz.league.basic.api.result.BzMatchListResult': {
      matches: components['schemas']['com.bz.league.basic.api.result.BzMatchResult'][];
      /** Format: int32 */
      totalPages: number;
      /** Format: int32 */
      totalCount: number;
      stats: {
        [key: string]: {
          [key: string]: number;
        };
      };
    };
    'com.bz.league.basic.api.result.BzMatchResult': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 运动ID
       */
      sportId: number;
      /** @description 运动名称 */
      sportName: string;
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 地区ID
       */
      regionId: number;
      /** @description 地区名称 */
      regionName: string;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /** @description 比赛名称 */
      name: string;
      /** @description 比赛描述 */
      description: string;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /** @description 比赛地点 */
      matchLocation: string;
      /** @description 体育场名称 */
      stadium: string;
      /** @description 裁判姓名 */
      referee: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 状态详情描述 */
      statusDesc: string;
      /** @description 比赛轮次 */
      round: string;
      roundname: components['schemas']['com.bz.league.basic.api.result.BzRoundNameResult'];
      result: components['schemas']['com.bz.league.basic.api.result.BzResult'];
      /** @description 比赛标签（如'热门'、'友谊赛'等） */
      tag: string;
      homeTeam: components['schemas']['com.bz.league.basic.api.result.BzTeamResult'];
      awayTeam: components['schemas']['com.bz.league.basic.api.result.BzTeamResult'];
      /**
       * Format: int64
       * @description 阶段时间
       */
      periodTime: number;
      bzMarketOdds: components['schemas']['com.bz.odds.api.dto.MarketBatchResponse'];
      /** @description 赔率信息 */
      marketOdds: components['schemas']['com.bz.odds.api.dto.response.MarketResponse'][];
      /**
       * Format: int32
       * @description 总盘口数量
       */
      totalMarkets: number;
    };
    /** @description 队伍阵容 */
    'com.bz.league.basic.api.result.BzPlayerResult': {
      /**
       * Format: int64
       * @description 参赛者ID
       */
      id: number;
      /** @description 姓名 */
      name: string;
      /** @description 全名 */
      fullname: string;
      /** @description 国籍 */
      nationality: string;
      /**
       * Format: int32
       * @description 球衣号码
       */
      shirtNumber: number;
      /** @description 头像图片URL */
      imageUrl: string;
      /**
       * Format: date-time
       * @description 出生日期
       */
      birthDate: string;
      /** @description 身高 */
      height: number;
      /** @description 体重 */
      weight: number;
      /** @description 市场价值 */
      marketValue: number;
      /** @description 位置 */
      position: string;
      /** @description 描述 */
      detail: string;
    };
    /** @description 比赛结果 */
    'com.bz.league.basic.api.result.BzResult': {
      home: string;
      away: string;
      period: string;
      winner: string;
    };
    /** @description 比赛轮次名称 */
    'com.bz.league.basic.api.result.BzRoundNameResult': {
      name: string;
      _doc: string;
      _id: string;
    };
    /** @description 客队比赛数据 */
    'com.bz.league.basic.api.result.BzTeamResult': {
      /**
       * Format: int64
       * @description 队伍id
       */
      teamId: number;
      /** @description 队伍名称 */
      teamName: string;
      /** @description 队伍logo */
      logoUrl: string;
      /**
       * Format: int32
       * @description 队伍得分
       */
      score: number;
      /** @description 队伍阵容 */
      player: components['schemas']['com.bz.league.basic.api.result.BzPlayerResult'][];
    };
    /** @description 赔率信息 */
    'com.bz.odds.api.dto.MarketBatchResponse': {
      marketList: components['schemas']['com.bz.odds.api.dto.response.MarketResponse'][];
      /** Format: int32 */
      totalMarkets: number;
    };
    /**
     * 盘口投注项赔率列表
     * @description 盘口投注项赔率列表
     */
    'com.bz.odds.api.dto.MarketSpecifierDTO': {
      matchCode: string;
      /** Format: int32 */
      status: number;
      outcomes: components['schemas']['com.bz.odds.api.dto.OutcomeDTO'][];
    };
    'com.bz.odds.api.dto.OutcomeDTO': {
      code: string;
      outcomeId: string;
      outcomeName: string;
      odds: number;
      /** Format: int32 */
      active: number;
      /** Format: int64 */
      updateTime: number;
      /** Format: int32 */
      phase: number;
    };
    /**
     * 按玩法类型分组的赔率
     * @description 赔率信息
     */
    'com.bz.odds.api.dto.response.MarketResponse': {
      /**
       * 盘口ID
       * @description 盘口ID
       */
      marketId: string;
      /**
       * 玩法类型
       * @description 玩法类型
       */
      marketName: string;
      /** Format: int32 */
      marketTabType: number;
      /**
       * 盘口投注项赔率列表
       * @description 盘口投注项赔率列表
       */
      marketSpecifierList: components['schemas']['com.bz.odds.api.dto.MarketSpecifierDTO'][];
    };
    'com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BzMatchDetailResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BzMatchDetailResult'];
    };
    'com.bz.league.basic.api.result.BzMatchDetailResult': {
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /**
       * Format: int64
       * @description 运动ID
       */
      sportId: number;
      /** @description 运动名称 */
      sportName: string;
      /**
       * Format: int64
       * @description 关联联赛ID
       */
      leagueId: number;
      /** @description 联赛名称 */
      leagueName: string;
      /**
       * Format: int64
       * @description 地区ID
       */
      regionId: number;
      /** @description 地区名称 */
      regionName: string;
      /** @description 联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 赛季ID
       */
      seasonId: number;
      /** @description 赛季名称 */
      seasonName: string;
      /** @description 比赛名称 */
      name: string;
      /** @description 比赛描述 */
      description: string;
      /**
       * Format: int64
       * @description 开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 结束时间（时间戳）
       */
      endTime: number;
      /** @description 比赛地点 */
      matchLocation: string;
      /** @description 体育场名称 */
      stadium: string;
      /** @description 裁判姓名 */
      referee: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 状态详情描述 */
      statusDesc: string;
      /** @description 比赛轮次 */
      round: string;
      roundname: components['schemas']['com.bz.league.basic.api.result.BzRoundNameResult'];
      result: components['schemas']['com.bz.league.basic.api.result.BzResult'];
      /** @description 比赛结果信息 */
      resultInfo: string;
      /** @description 比赛标签（如'热门'、'友谊赛'等） */
      tag: string;
      homeTeam: components['schemas']['com.bz.league.basic.api.result.BzTeamResult'];
      awayTeam: components['schemas']['com.bz.league.basic.api.result.BzTeamResult'];
      /**
       * Format: int64
       * @description 阶段时间
       */
      periodTime: number;
      /** @description 统计数据 */
      stats: components['schemas']['com.bz.league.basic.api.result.BzMatchDetailResult$MatchStat'][];
      /** @description sportradar联赛id */
      sportradarLeagueId: string;
      /** @description sportradar地区id */
      sportradarRegionId: string;
      /** @description sportradar运动id */
      sportradarSportId: string;
      /** @description sportradar比赛id */
      sportradarMatchId: string;
      marketOdds: components['schemas']['com.bz.league.basic.api.result.MarketOdds'][];
    };
    /** @description 统计数据 */
    'com.bz.league.basic.api.result.BzMatchDetailResult$MatchStat': {
      /** @description 统计项名称 */
      name: string;
      value: components['schemas']['com.bz.league.basic.api.result.BzMatchDetailResult$StatValue'];
    };
    /** @description 统计值 */
    'com.bz.league.basic.api.result.BzMatchDetailResult$StatValue': {
      /** @description 主队数值 */
      home: string;
      /** @description 客队数值 */
      away: string;
    };
    'com.bz.league.basic.api.result.MarketOdds': {
      /**
       * Format: int64
       * @description 赔率ID
       */
      id: number;
      /**
       * Format: int64
       * @description 盘口来源博彩公司ID
       */
      bookmakerId: number;
      /** @description 赔率唯一code */
      code: string;
      /**
       * Format: int64
       * @description 队伍ID
       */
      teamId: number;
      /** @description 队伍名称 */
      teamName: string;
      /** @description 玩法唯一code */
      marketTypeCode: string;
      /**
       * Format: int32
       * @description 玩法类型
       */
      marketType: number;
      /**
       * Format: int32
       * @description 玩法子类型
       */
      marketSubType: number;
      /**
       * Format: int32
       * @description 时间类型：0 - 常规时间，1 - 前半场， 2 - 后半场， 3 - 加时赛， 4 - 点球大战
       */
      periodType: number;
      /** @description 详细规则 */
      rule: string;
      /** @description 详细描述 */
      desc: string;
      /** @description 盘口唯一代码 */
      oddsMarketCode: string;
      /**
       * Format: int64
       * @description 生效时间
       */
      marketEffectiveTime: number;
      /**
       * Format: int64
       * @description 过期时间
       */
      marketExpirationTime: number;
      /**
       * Format: int32
       * @description 盘口状态: 0-开盘 1-封盘 2-结算中 3-已结算
       */
      marketStatus: number;
      /** @description 赔率 */
      oddsValue: number;
      /** @description 前一个赔率 */
      preOddsValue: number;
      /** @description 初始赔率 */
      baseOddsValue: number;
      /**
       * Format: int32
       * @description 赔率状态
       */
      oddsStatus: number;
      /**
       * Format: int32
       * @description 0-赛前盘 1-滚球盘
       */
      oddsType: number;
      /**
       * Format: int64
       * @description 创建时间
       */
      createTime: number;
      /**
       * Format: int64
       * @description 更新时间
       */
      updateTime: number;
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.server.adapt.result.BzPopularLeagueResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.server.adapt.result.BzPopularLeagueResult'][];
    };
    'com.bz.league.basic.server.adapt.result.BzPopularLeagueResult': {
      /**
       * Format: int64
       * @description 体育运动ID
       */
      sportId: number;
      /** @description 体育运动名称 */
      sportName: string;
      /** @description 体育运动logo */
      sportLogoUrl: string;
      /**
       * Format: int64
       * @description 国家/地区ID
       */
      regionId: number;
      /** @description 国家/地区名称 */
      regionName: string;
      /** @description 国家/地区名称logo */
      regionLogoUrl: string;
      /**
       * Format: int64
       * @description 具体联赛ID
       */
      leagueId: number;
      /** @description 具体联赛名称 */
      leagueName: string;
      /** @description 具体联赛logo */
      leagueLogoUrl: string;
      /**
       * Format: int64
       * @description 比赛ID
       */
      id: number;
      /** @description 比赛名称 */
      name: string;
      /**
       * Format: int32
       * @description 比赛状态
       */
      matchStatus: number;
      /** @description 状态描述 */
      statusDesc: string;
      /**
       * Format: int64
       * @description 比赛开始时间（时间戳）
       */
      startTime: number;
      /**
       * Format: int64
       * @description 比赛结束时间（时间戳）
       */
      endTime: number;
      result: components['schemas']['com.bz.league.basic.api.result.BzResult'];
      homeTeam: components['schemas']['com.bz.league.basic.api.result.BzTeamResult'];
      awayTeam: components['schemas']['com.bz.league.basic.api.result.BzTeamResult'];
      /** @description 赔率信息 */
      marketOdds: components['schemas']['com.bz.league.basic.api.result.MarketOdds'][];
    };
    'com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BzMatchResult': {
      success: boolean;
      errCode: string;
      errMessage: string;
      data: components['schemas']['com.bz.league.basic.api.result.BzMatchResult'][];
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  uploadFile: {
    parameters: {
      query: {
        /** @description 文件 */
        undefined: string;
      };
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'multipart/form-data': {
          /** Format: binary */
          file: string;
        };
      };
    };
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.lang.String'];
        };
      };
    };
  };
  getSports_4: {
    parameters: {
      query?: never;
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BasicLeagueResult'];
        };
      };
    };
  };
  getTopSports: {
    parameters: {
      query?: never;
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.server.adapt.result.BzTopLeagueResult'];
        };
      };
    };
  };
  getMatches: {
    parameters: {
      query?: {
        /**
         * @description 运动类型
         * @example SOCCER
         */
        sport?:
          | 'SOCCER'
          | 'TENNIS'
          | 'ICE_HOCKEY'
          | 'BASKETBALL'
          | 'HANDBALL'
          | 'VOLLEYBALL'
          | 'BASEBALL'
          | 'FLOORBALL'
          | 'GOLF'
          | 'BOXING'
          | 'RUGBY'
          | 'AUSSIE_RULES'
          | 'BANDY'
          | 'AMERICAN_FOOTBALL'
          | 'CYCLING'
          | 'SNOOKER'
          | 'TABLE_TENNIS'
          | 'CRICKET'
          | 'DARTS'
          | 'FIELD_HOCKEY'
          | 'WATERPOLO'
          | 'CURLING'
          | 'FUTSAL'
          | 'BADMINTON'
          | 'BOWLS'
          | 'CHESS'
          | 'BEACH_VOLLEY'
          | 'SQUASH'
          | 'RINK_HOCKEY'
          | 'LACROSSE'
          | 'FORMULA_1'
          | 'SKI_JUMPING'
          | 'BEACH_SOCCER'
          | 'PESAPALLO'
          | 'PADEL'
          | 'RALLY'
          | 'MMA'
          | 'ESPORT_OVERWATCH'
          | 'INDY_RACING'
          | 'SPEEDWAY'
          | 'GAELIC_FOOTBALL'
          | 'GAELIC_HURLING'
          | 'ESOCCER'
          | 'KABADDI'
          | 'BASKETBALL_3X3'
          | 'FORMULA_2'
          | 'BEACH_HANDBALL'
          | 'MOTORCYCLE_RACING'
          | 'STOCK_CAR_RACING'
          | 'SOCCER_SPECIALS'
          | 'ALL';
        /**
         * @description 赛事ID
         * @example 1
         */
        leagueId?: string;
        /**
         * @description 标签
         * @example 热门
         */
        tag?: string;
        /**
         * @description 比赛状态列表 状态 0:未开始 1:进行中 2:已结束 99:全部
         * @example 0,1,2
         */
        status?: number[];
        /**
         * @description 是否获取比赛场数
         * @example true
         */
        isCounting?: boolean;
        /**
         * @description 第几页
         * @example 1
         */
        page?: number;
        /**
         * @description 每页大小
         * @example 10
         */
        pageSize?: number;
      };
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BzMatchListResult'];
        };
      };
    };
  };
  getMatchDetails: {
    parameters: {
      query?: never;
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path: {
        /**
         * @description 比赛ID
         * @example 1
         */
        matchId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BzMatchDetailResult'];
        };
      };
    };
  };
  getTopLeagues: {
    parameters: {
      query?: never;
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.server.adapt.result.BzTopLeagueResult'];
        };
      };
    };
  };
  getSideBar: {
    parameters: {
      query?: {
        /**
         * @description 体育类目，不选，默认ALL
         * @example SOCCER
         */
        sport?:
          | 'SOCCER'
          | 'TENNIS'
          | 'ICE_HOCKEY'
          | 'BASKETBALL'
          | 'HANDBALL'
          | 'VOLLEYBALL'
          | 'BASEBALL'
          | 'FLOORBALL'
          | 'GOLF'
          | 'BOXING'
          | 'RUGBY'
          | 'AUSSIE_RULES'
          | 'BANDY'
          | 'AMERICAN_FOOTBALL'
          | 'CYCLING'
          | 'SNOOKER'
          | 'TABLE_TENNIS'
          | 'CRICKET'
          | 'DARTS'
          | 'FIELD_HOCKEY'
          | 'WATERPOLO'
          | 'CURLING'
          | 'FUTSAL'
          | 'BADMINTON'
          | 'BOWLS'
          | 'CHESS'
          | 'BEACH_VOLLEY'
          | 'SQUASH'
          | 'RINK_HOCKEY'
          | 'LACROSSE'
          | 'FORMULA_1'
          | 'SKI_JUMPING'
          | 'BEACH_SOCCER'
          | 'PESAPALLO'
          | 'PADEL'
          | 'RALLY'
          | 'MMA'
          | 'ESPORT_OVERWATCH'
          | 'INDY_RACING'
          | 'SPEEDWAY'
          | 'GAELIC_FOOTBALL'
          | 'GAELIC_HURLING'
          | 'ESOCCER'
          | 'KABADDI'
          | 'BASKETBALL_3X3'
          | 'FORMULA_2'
          | 'BEACH_HANDBALL'
          | 'MOTORCYCLE_RACING'
          | 'STOCK_CAR_RACING'
          | 'SOCCER_SPECIALS'
          | 'ALL';
        /**
         * @description 需要获取类目的深度，深度 1:到三级类目 2:到四级类目 3:到五级类目，赛季级别；最深只能到五级类目
         * @example THREE
         */
        level?: 'ONE' | 'TWO' | 'THREE' | 'FOUR' | 'FIVE';
        /**
         * @description 状态 0:未开始 1:进行中 2:已结束 3:异常 99:全部
         * @example 99
         */
        status?: number[];
      };
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BasicLeagueResult'];
        };
      };
    };
  };
  getPopularLeagues: {
    parameters: {
      query?: never;
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.server.adapt.result.BzPopularLeagueResult'];
        };
      };
    };
  };
  getLeaguesWithOdds: {
    parameters: {
      query?: {
        /**
         * @description 体育类目
         * @example SOCCER
         */
        sport?:
          | 'SOCCER'
          | 'TENNIS'
          | 'ICE_HOCKEY'
          | 'BASKETBALL'
          | 'HANDBALL'
          | 'VOLLEYBALL'
          | 'BASEBALL'
          | 'FLOORBALL'
          | 'GOLF'
          | 'BOXING'
          | 'RUGBY'
          | 'AUSSIE_RULES'
          | 'BANDY'
          | 'AMERICAN_FOOTBALL'
          | 'CYCLING'
          | 'SNOOKER'
          | 'TABLE_TENNIS'
          | 'CRICKET'
          | 'DARTS'
          | 'FIELD_HOCKEY'
          | 'WATERPOLO'
          | 'CURLING'
          | 'FUTSAL'
          | 'BADMINTON'
          | 'BOWLS'
          | 'CHESS'
          | 'BEACH_VOLLEY'
          | 'SQUASH'
          | 'RINK_HOCKEY'
          | 'LACROSSE'
          | 'FORMULA_1'
          | 'SKI_JUMPING'
          | 'BEACH_SOCCER'
          | 'PESAPALLO'
          | 'PADEL'
          | 'RALLY'
          | 'MMA'
          | 'ESPORT_OVERWATCH'
          | 'INDY_RACING'
          | 'SPEEDWAY'
          | 'GAELIC_FOOTBALL'
          | 'GAELIC_HURLING'
          | 'ESOCCER'
          | 'KABADDI'
          | 'BASKETBALL_3X3'
          | 'FORMULA_2'
          | 'BEACH_HANDBALL'
          | 'MOTORCYCLE_RACING'
          | 'STOCK_CAR_RACING'
          | 'SOCCER_SPECIALS'
          | 'ALL';
        /** @description 状态 - 比赛前状态
         *
         *     - 0 - Not started（未开始） ：比赛尚未开始
         *     - 61 - Start delayed（开始延迟） ：比赛开始时间延迟
         *     - 常规比赛时间
         *
         *     - 6 - 1st half（上半场） ：比赛进行中，上半场阶段
         *     - 7 - 2nd half（下半场） ：比赛进行中，下半场阶段
         *     - 31 - Halftime（中场休息） ：上下半场之间的休息时间
         *     - 加时赛相关
         *
         *     - 32 - Awaiting extra time（等待加时赛） ：常规时间结束，等待进入加时赛
         *     - 40 - Overtime (加时赛 30分钟)- 41 - 1st extra（加时赛上半场） ：加时赛第一个15分钟
         *     - 42 - 2nd extra（加时赛下半场） ：加时赛第二个15分钟
         *     - 33 - Extra time halftime（加时赛中场休息） ：加时赛上下半场之间的休息
         *     - 点球大战
         *
         *     - 34 - Awaiting penalties（等待点球大战） ：加时赛结束，等待进入点球大战
         *     - 50 - Penalties（点球大战） ：正在进行点球大战
         *     - 比赛结束状态
         *
         *     - 100 - Ended（结束） ：比赛正常结束（90分钟内结束）
         *     - 110 - AET（加时赛后结束） ：After Extra Time，加时赛后结束
         *     - 120 - AP（点球大战后结束） ：After Penalties，点球大战后结束
         *     - 异常状态
         *
         *     - 60 - Postponed（推迟） ：比赛被推迟到另一个日期
         *     - 70 - Cancelled（取消） ：比赛被完全取消
         *     - 80 - Interrupted（中断） ：比赛因各种原因中断（天气、安全等）
         *     - 90 - Abandoned（放弃） ：比赛被永久终止，无法完成不传默认全部状态 */
        status?: number[];
      };
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BasicLeagueResult'];
        };
      };
    };
  };
  getBzMatchListByIds: {
    parameters: {
      query: {
        ids: number[];
      };
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BzMatchResult'];
        };
      };
    };
  };
  getAllLeague: {
    parameters: {
      query?: never;
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseCom.bz.league.basic.api.result.BasicLeagueResult'];
        };
      };
    };
  };
  getFeaturedEvents: {
    parameters: {
      query?: never;
      header?: {
        /** @description 客户端类型 /api 开头的所有接口gateway都会限制
         *     规则如下：[xx业务]-[xx端]
         *     BZ业务：
         *     1.网页端 BZ-WEB
         *     2.app端 BZ-APP
         *     3.小程序端 BZ-AAPLET
         *     dev、test环境在swagger上可以使用默认值：SWAGGER
         *      */
        'X-Client-Type'?: string;
      };
      path: {
        /**
         * @description 运动类型
         * @example Soccer
         */
        sport: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description OK */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': components['schemas']['com.bz.common.dto.SingleResponseJava.util.ListCom.bz.league.basic.api.result.BasicMatchResult'];
        };
      };
    };
  };
}
export enum ApiPaths {
  uploadFile = '/api/league/adapt/bzGoal/file/upload',
  getSports_4 = '/api/league/adapt/bzGoal/sports',
  getTopSports = '/api/league/adapt/bzGoal/sports/top',
  getMatches = '/api/league/adapt/bzGoal/matches/list',
  getMatchDetails = '/api/league/adapt/bzGoal/matches/detail/{matchId}',
  getTopLeagues = '/api/league/adapt/bzGoal/leagues/top',
  getSideBar = '/api/league/adapt/bzGoal/leagues/sub',
  getPopularLeagues = '/api/league/adapt/bzGoal/leagues/popular',
  getLeaguesWithOdds = '/api/league/adapt/bzGoal/leagues/getLeaguesWithOdds',
  getBzMatchListByIds = '/api/league/adapt/bzGoal/getBzMatchListByIds',
  getAllLeague = '/api/league/adapt/bzGoal/getAllLeague',
  getFeaturedEvents = '/api/league/adapt/bzGoal/events/{sport}/list',
}
